import script from "./insureTab.vue?vue&type=script&setup=true&lang=js"
export * from "./insureTab.vue?vue&type=script&setup=true&lang=js"

import "./insureTab.vue?vue&type=style&index=0&id=1d8511fc&lang=scss"

const __exports__ = script;

export default __exports__